import { cx } from '@emotion/css'
import React from 'react'

export interface IconChevronRightTNProps {
    className?: string
    color?: string
}

export const IconChevronRightTN: React.FC<IconChevronRightTNProps> = ({
    className,
    color = 'currentColor',
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={24}
        height={24}
        className={cx(className, 'icon-chevron-right-tn')}
    >
        <path
            d="M9 18L15 12L9 6"
            stroke={color}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="transparent"
        />
    </svg>
)
IconChevronRightTN.displayName = 'IconChevronRightTN'
